export class CSAlertConfiguration {
    constructor(
        id,
        type,
        value,
        frequency,
        threshold,
        lastActivation,
        description,
        actionType
    ) {
        this.id = id;
        this.type = type;
        this.value = value;
        this.frequency = frequency;
        this.threshold = threshold;
        this.lastActivation = lastActivation;
        this.description = description;
        this.actionType = actionType;
    }

    static createFromResponseData(responseData) {
        return new CSAlertConfiguration(
            responseData.id,
            responseData.type,
            responseData.value,
            responseData.frequency,
            responseData.threshold,
            responseData.lastActivation,
            responseData.description,
            responseData.actionType
        );
    }

    static ALLOWED_TYPES = {
        EVENT_CODE: 'event_code',
        EVENT_CATEGORY: 'event_category'
    };
    
    static ALLOWED_ACTION_TYPES = {
        INCIDENCE: 'incidence',
        ALERT: 'alert'
    };
}
